import type Question from './Question'

export default class QuestionAdmission implements Question {
  componentName = 'QuestionAdmission'
  date: string
  reason: string

  constructor(data: Partial<QuestionAdmission> = {}) {
    this.date = data?.date ?? ''
    this.reason = data?.reason ?? ''
  }

  get deconstructedDate() {
    if (!this.date) {
      return { day: '01', month: '00', year: '0000' }
    }

    const [day, month, year] = this.date.split('/')
    return { day, month, year }
  }

  set month(month: string) {
    const { day, year } = this.deconstructedDate
    this.date = `${day}/${month}/${year}`
  }
  get month() {
    return this.deconstructedDate.month
  }

  set year(year: string) {
    const { day, month } = this.deconstructedDate
    this.date = `${day}/${month}/${year}`
  }
  get year() {
    return this.deconstructedDate.year
  }

  isEmpty() {
    return !this.date || !this.reason
  }

  reset() {
    this.date = ''
    this.reason = ''
  }
}
